import { Button, Modal, Spin } from 'antd-v5';
import styles from './index.module.scss';
import type { MyMysteryBoxItem, MyMysteryBoxPagination } from '../../hooks/types';
import Gift from '../MysteryBoxModal/Gift';
import { useLang } from '@/i18n';

interface MyMysteryBoxModalProps {
    open: boolean;
    onCancel?: () => void;
    list?: MyMysteryBoxItem[];
    loading?: boolean;
    pagination?: MyMysteryBoxPagination;
    onLoadMore?: () => void;
}

const MyMysteryBoxModal: React.FC<MyMysteryBoxModalProps> = ({ open, onCancel, list = [], loading, pagination, onLoadMore }) => {
    const { t } = useLang('MyMysteryBoxModal');

    const BOX_STATUS_LABEL: Record<number, string> = {
        1: t('pending'),
        2: t('pending'),
        3: t('issued'),
        4: t('expired'),
    };

    const getNoteContent = (status: number): string | null => {
        if (status === 1 || status === 2) return t('note_pending');
        if (status === 3) return t('note_issued');
        if (status === 4) return t('note_rejected');
        return null;
    };

    const boxStatusClass: Record<number, string> = {
        1: 'pending',
        2: 'pending',
        3: 'issued',
        4: 'expired',
    };

    return (
        <Modal className={styles.MyMysteryBoxModal} open={open} onCancel={onCancel} footer={null} centered maskClosable={false} title={t('title')}>
            <Spin spinning={loading}>
                <div className="modal-body">
                    {list.length === 0 && !loading ? (
                        <p className="empty-tip">{t('not_participation_yet')}</p>
                    ) : (
                        <ul className="box-list">
                            {list.map((item) => (
                                <li key={item.id} className="box-item">
                                    <div className="box-meta">
                                        <span className="box-sn">
                                            {t('sn')}
                                            {item.sn}
                                        </span>
                                        <span className="box-time">
                                            {t('draw_time')} {item.createTime}
                                        </span>
                                        <span className={`box-status ${boxStatusClass[item.boxStatus]}`}>{BOX_STATUS_LABEL[item.boxStatus] ?? '-'}</span>
                                    </div>
                                    {item.ruleGiftRespVos?.length > 0 && (
                                        <ul className="gift-list">
                                            {item.ruleGiftRespVos.map((gift) => (
                                                <li key={gift.id} className="gift-item">
                                                    <Gift className="gift-item-left" type={gift.type} amount={gift.amount || 0} />

                                                    <div className="gift-item-name">{gift.name}</div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {getNoteContent(item.boxStatus) && (
                                        <div className="description">
                                            <p className="note-label">{t('note_label')}</p>
                                            <p>{getNoteContent(item.boxStatus)}</p>
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                    {pagination?.hasNext && (
                        <button className="load-more-btn" onClick={onLoadMore} disabled={loading}>
                            Load More
                        </button>
                    )}

                    <div className="modal-footer">
                        <Button type="primary" shape="round" className="action-btn" onClick={onCancel}>
                            {'OK'}
                        </Button>
                    </div>
                </div>
            </Spin>
        </Modal>
    );
};

export default MyMysteryBoxModal;
